import React from "react";
import { Outlet } from "react-router-dom";

import { Box } from "@mui/material";
import { CustomHelmet } from "components";

export const BillingLayout = () => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 64px)",
        width: "100%",
      }}
    >
      <CustomHelmet title="Billing" />
      <Outlet />
    </Box>
  );
};
